/* Jquery */
var $ = require("jquery");

function cantine () {
    
    /* CAMBIO FERNANDO */ 
    /* $( ".general_card" ).click(function() {
        $('.general_card').removeClass('active_card');
        $(this).addClass('active_card');
    });
    */
    
    /* CAMBIO FERNANDO */ 
}

export default cantine;